import React from "react";
import personalloan from "../assets/financialInsignt/personalloan.png";
// import emiplaning from "../assets/financialInsignt/emiplaning.png";
import digitalloan from "../assets/financialInsignt/digitalloan.png";

const insightsData = [
  {
    id: 1,
    tag: "PERSONAL LOAN",
    title: "Understanding Personal Loans",
    subtext: "Everything you should know before applying for your first personal loan.",
    image: personalloan,
    link: "#"
  },
  // {
  //   id: 2,
  //   tag: "EMI PLANNING",
  //   title: "Choosing the Right EMI",
  //   subtext: "Learn how to select a repayment plan that fits comfortably within your monthly budget.",
  //   image: emiplaning,
  //   link: "#"
  // },
  {
    id: 3,
    tag: "DIGITAL LOAN",
    title: "Improve Your Loan Eligibility",
    subtext: "Simple ways to strengthen your loan application before applying.",
    image: digitalloan,
    link: "#"
  }
];

const FinancialInsights: React.FC = () => {
  return (
    <section className="w-full  md:pt-28 pb-0 flex flex-col items-center">
      <div className="max-w-[1400px] w-full px-6 lg:px-20 flex flex-col">
        {/* Header Block */}
        <div className="hidden md:flex items-center gap-3 text-neutral-500 uppercase tracking-[0.15em] text-xs md:text-sm font-bold mb-3">
          <span className="w-7 h-[1.5px] bg-neutral-400" />
          <span>Financial Insights</span>
        </div>

        <h2 className="text-[24px] leading-[24px] font-kualine md:font-sans font-semibold md:font-black not-italic tracking-normal text-center text-neutral-900 mt-2 md:text-5xl md:lg:text-[54px] md:leading-[1.15] md:tracking-tight md:text-left">
          Learn today
          <span className="block text-[#DE3226] mt-2">Borrow smarter tomorrow.</span>
        </h2>

        {/* Cards Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8 lg:gap-10 mt-12 md:mt-16 justify-items-center">
          {insightsData.map((item) => (
            <div
              key={item.id}
              className="w-full max-w-[480px] flex flex-col bg-[#FDFBF9] md:bg-white border border-[#DE3226] md:border-[#F3D1C9] rounded-[24px] md:rounded-[20px] overflow-hidden shadow-[0_4px_12px_rgba(222,50,38,0.02)] hover:shadow-[0_8px_24px_rgba(222,50,38,0.06)] transition-all duration-300"
            >
              {/* Image Box */}
              <div className="relative aspect-[4/3] w-full overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover"
                />
                <div
                  className="absolute inset-0 pointer-events-none"
                  style={{ backgroundColor: '#E5393526' }}
                />
              </div>

              {/* Text Box */}
              <div className="p-6 md:p-8 flex flex-col flex-grow">
                <span className="text-[11px] md:text-xs font-bold text-neutral-800 md:text-neutral-500 uppercase tracking-widest">
                  {item.tag}
                </span>

                <h3 className="text-lg md:text-xl lg:text-[22px] font-semibold text-neutral-800 leading-snug mt-3">
                  {item.title}
                </h3>

                <p className="text-neutral-600 text-sm md:text-[15px] leading-relaxed mt-2.5">
                  {item.subtext}
                </p>

                <div className="mt-auto pt-6">
                  <a
                    href={item.link}
                    className="inline-flex items-center gap-1.5 text-[#1D4ED8] hover:text-[#1e40af] font-bold text-[15px] group transition-colors"
                  >
                    <span>Read More</span>
                    <span className="transition-transform group-hover:translate-x-1 font-semibold">→</span>
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Full-width Stats Bar */}
      <div className="w-full bg-[#DE3226] mt-16 md:mt-24 py-10 md:py-14 px-6 hidden md:block">
        <div className="max-w-[1400px] mx-auto grid grid-cols-2 lg:grid-cols-4 gap-y-8 lg:gap-y-0 text-white">
          {/* Stat 1 */}
          <div className="flex flex-col items-center text-center px-4 lg:border-r lg:border-white/20 last:border-0">
            <span className="text-3xl md:text-4xl lg:text-[42px] font-black leading-none">₹20 Cr</span>
            <span className="text-white/90 text-xs md:text-sm lg:text-[15px] font-bold mt-2.5 tracking-wide">Total Loans Disbursed</span>
          </div>
          {/* Stat 2 */}
          <div className="flex flex-col items-center text-center px-4 lg:border-r lg:border-white/20 last:border-0">
            <span className="text-3xl md:text-4xl lg:text-[42px] font-black leading-none">20000+</span>
            <span className="text-white/90 text-xs md:text-sm lg:text-[15px] font-bold mt-2.5 tracking-wide">Happy Borrowers</span>
          </div>
          {/* Stat 3 */}
          <div className="flex flex-col items-center text-center px-4 lg:border-r lg:border-white/20 last:border-0">
            <span className="text-3xl md:text-4xl lg:text-[42px] font-black leading-none">98%</span>
            <span className="text-white/90 text-xs md:text-sm lg:text-[15px] font-bold mt-2.5 tracking-wide">Approval Rate</span>
          </div>
          {/* Stat 4 */}
          <div className="flex flex-col items-center text-center px-4 last:border-0">
            <span className="text-3xl md:text-4xl lg:text-[42px] font-black leading-none">4 min</span>
            <span className="text-white/90 text-xs md:text-sm lg:text-[15px] font-bold mt-2.5 tracking-wide">Avg. Approval Time</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FinancialInsights;
